function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".menu-item:hover" + shadowSelector + ",.menu-item[data-active='true']" + shadowSelector + " {background: #eef4ff;color: #0b5cab;}.menu-item" + shadowSelector + " {color: #006dcc;display: flex;font-weight: bold;padding: 8px 24px;text-align: left;text-decoration: none;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet];